import { combineReducers } from 'redux';
import associationReducer from './Association/associationReducer';
import cohortReducer from './Cohort/cohortReducer';
import cohortsOrgsReducer from './Cohort/cohortsOrgsReducer';
import cohortsSelectionsReducer from './Cohort/cohortsSelectionsReducer';
import flashMessagesReducer from './FlashMessage/flashMessagesReducer';
import impersonateReducer from './Impersonate/impersonateReducer';
import institutionsReducer from './Institutions/institutionsReducer';
import notificationsReducer from './Notifications/notificationsReducer';
import pageConfigReducer from './Page/pageConfigReducer';
import loggedUserDetailsReducer from './User/loggedUserDetailsReducer';
import usersListReducer from './User/usersListReducer';

export default combineReducers({
  FlashMessages: flashMessagesReducer,
  Notifications: notificationsReducer,
  Users: usersListReducer,
  AppSession: loggedUserDetailsReducer,
  Impersonate: impersonateReducer,
  Cohort: cohortReducer,
  CohortsOrgs: cohortsOrgsReducer,
  CohortsSelections: cohortsSelectionsReducer,
  Association: associationReducer,
  Institutions: institutionsReducer,
  Page: pageConfigReducer,
})
